var render, staticRenderFns
import script from "./c-user-selector-config.vue?vue&type=script&lang=js"
export * from "./c-user-selector-config.vue?vue&type=script&lang=js"
import style0 from "./c-user-selector-config.vue?vue&type=style&index=0&id=6229b4a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6229b4a8",
  null
  
)

export default component.exports